import fetchCaveat from '../Services/fetchCaveats';

export default () => async (dispatch) => {

  dispatch(fetchCaveat());

}